import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/requisitantes/pagamentos?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterFornecedor(cpfcnpj) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/pagamentos/fornecedor/${cpfcnpj}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesasDisponiveis(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/requisitantes/pagamentos/${pagamentoId}/despesasdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarDespesas(pagamentoDespesas) {
        return axiosJwt
            .post(
                `${api}/despesasgerais/requisitantes/pagamentos/${pagamentoDespesas.pagamentoId}/associardespesas`,
                pagamentoDespesas
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarDespesa(pagamentoDespesa) {
        return axiosJwt
            .post(
                `${api}/despesasgerais/requisitantes/pagamentos/${pagamentoDespesa.pagamentoId}/desassociardespesa`,
                pagamentoDespesa
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFornecedores() {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/pagamentos/fornecedores`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    inserirPagamento(inserirPagamentoForm) {
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/pagamentos/`, inserirPagamentoForm)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterAnexos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/requisitantes/pagamentos/${pagamentoId}/anexos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoAnexoId', pagamentoAnexo.tipoId)
        formData.append('descricao', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroNotaDocumento', pagamentoAnexo.numeroNotaDocumento)
        formData.append('codigoVerificacao', pagamentoAnexo.codigoVerificacao)
        if (pagamentoAnexo.dataEmissao != '') {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }

        return axiosJwt
            .post(
                `${api}/despesasgerais/requisitantes/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoAnexoId', pagamentoAnexo.pagamentoAnexoId)
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoAnexoId', pagamentoAnexo.tipoId)
        formData.append('descricao', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroNotaDocumento', pagamentoAnexo.numeroNotaDocumento)
        formData.append('codigoVerificacao', pagamentoAnexo.codigoVerificacao)
        if (pagamentoAnexo.dataEmissao != '') {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }

        return axiosJwt
            .patch(
                `${api}/despesasgerais/requisitantes/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/despesasgerais/requisitantes/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/pagamentos/anexos/${pagamentoAnexoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/pagamentos/anexos/${pagamentoAnexoId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarPagamentoParaAnalise(pagamentoDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/pagamentos/enviar`, pagamentoDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/${pagamentoId}/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCertidoes(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/sgtec/uabs/pagamentos/${pagamentoId}/certidoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    
    obterDespesasCompraOutroFornecedor(pagamentoId, filtroDto) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/requisitantes/pagamentos/${pagamentoId}/despesascompra/filtrardespesas?cpfCnpjCodCfo=${
                        filtroDto.cpfCnpjCodCfo ? filtroDto.cpfCnpjCodCfo : ''
                    }&sequencial=${
                        filtroDto.sequencial ? filtroDto.sequencial : ''
                    }&movimentoId=${
                        filtroDto.movimentoId ? filtroDto.movimentoId : ''
                    }&fornecedorExterno=${
                        filtroDto.fornecedorExterno ? filtroDto.fornecedorExterno : ''
                    }`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}